import { render, staticRenderFns } from "./SkyscannerIcon.vue?vue&type=template&id=45f5867e&scoped=true&"
var script = {}
import style0 from "./SkyscannerIcon.vue?vue&type=style&index=0&id=45f5867e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5867e",
  null
  
)

export default component.exports